var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createRef, isValidElement, PureComponent } from 'react';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import { CloseOutlined } from '@feb-team/legao-icons-react';
import { defaultProps } from './defaults';
import ReactDOM from 'react-dom';
import { omit } from '../../Utils/object';
var bodyOverFlowCounter = 0;
var DrawerContext = React.createContext(null);
var Drawer = /** @class */ (function (_super) {
    __extends(Drawer, _super);
    function Drawer(props) {
        var _this = _super.call(this, props) || this;
        _this.divRef = createRef();
        _this.handleTransitionEnd = function (e) {
            if (e.propertyName == 'transform') {
                _this.props.afterVisibleChange(e);
            }
        };
        _this.close = function () {
            _this.setState({
                visible: false,
            }, function () {
                _this.props.onClose();
                document.body.classList.remove('overflow-hidden');
            });
        };
        _this.handleMaskClose = function () {
            _this.props.maskClosable && _this.close();
        };
        _this.handleCloseIcon = function () {
            _this.close();
        };
        _this.getPushDistance = function () {
            var push = _this.props.push;
            var distance;
            if (typeof push === 'boolean') {
                distance = push ? 180 : 0;
            }
            else {
                distance = push.distance;
            }
            return parseFloat(String(distance || 0));
        };
        _this.renderProvider = function (value) {
            _this.parentDrawer = value;
            var getContainer = _this.props.getContainer;
            var container = getContainer || document.body;
            return (React.createElement(DrawerContext.Provider, { value: _this }, getContainer === false
                ? _this.renderWrapper()
                : ReactDOM.createPortal(_this.renderWrapper(), container)));
        };
        _this.state = { visible: props.visible, push: false };
        return _this;
    }
    Drawer.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (nextProps.visible) {
            this.opened = true;
        }
        this.setState({
            visible: nextProps.visible,
        });
    };
    Drawer.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var _a;
        var _b = this.props, visible = _b.visible, getContainer = _b.getContainer;
        var container = getContainer;
        if (container == null || container == document.body) {
            if (this.state.visible == true) {
                document.body.classList.add('overflow-hidden');
            }
            else {
                --bodyOverFlowCounter;
                if (bodyOverFlowCounter == 0) {
                    document.body.classList.remove('overflow-hidden');
                }
            }
        }
        if (visible !== prevProps.visible && this.parentDrawer) {
            if (visible) {
                this.parentDrawer.push();
            }
            else {
                this.parentDrawer.pull();
            }
        }
        if (this.state.visible) {
            setTimeout(function () {
                var _a;
                (_a = _this.divRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('drawer-open');
            }, 0);
        }
        else {
            (_a = this.divRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove('drawer-open');
        }
    };
    Drawer.prototype.componentWillUnmount = function () {
        if (this.parentDrawer) {
            this.parentDrawer.pull();
            this.parentDrawer = null;
        }
    };
    Drawer.prototype.push = function () {
        this.setState({
            push: true,
        });
    };
    Drawer.prototype.pull = function () {
        this.setState({
            push: false,
        });
    };
    Drawer.prototype.renderCloseIcon = function () {
        var iconAtomics = ['w-2', 'h-2', 'fill-gray-400', 'ml-1', '-mt-px-2'];
        return this.props.close === false ? null : (React.createElement(SpanTag, { autoPrefixedClassName: "drawer-close", onClick: this.handleCloseIcon, atomics: ['cursor-pointer', 'text-sm', 'absolute'] },
            React.createElement(SpanTag, { atomics: iconAtomics },
                this.props.close === true ? React.createElement(CloseOutlined, null) : null,
                !isValidElement(this.props.close) && this.props.close ? this.props.close : null,
                isValidElement(this.props.close) ? this.props.close : null)));
    };
    Drawer.prototype.renderTitle = function () {
        var _a = this.props, titleStyle = _a.titleStyle, title = _a.title;
        return title ? (React.createElement(DivTag, { autoPrefixedClassName: "drawer-header", style: titleStyle, atomics: [
                'w-full',
                'h-px-56',
                'border-b',
                'border-gray-200',
                'text-black',
                'bg-white',
                'py-px-16',
                'px-px-24',
            ] },
            React.createElement(DivTag, { autoPrefixedClassName: "drawer-title" }, title),
            this.renderCloseIcon())) : null;
    };
    Drawer.prototype.renderFooter = function () {
        var _a = this.props, footer = _a.footer, footerStyle = _a.footerStyle;
        return footer ? (React.createElement(DivTag, { autoPrefixedClassName: "drawer-footer", style: footerStyle, atomics: [
                'w-full',
                'h-px-56',
                'border-t',
                'border-gray-200',
                'w-full',
                'py-px-16',
                'px-px-24',
            ] }, "Footer")) : null;
    };
    Drawer.prototype.getPushTransform = function (placement) {
        var distance = this.getPushDistance();
        if (placement === 'left' || placement === 'right') {
            return "translateX(" + (placement === 'left' ? distance : -distance) + "px)";
        }
        if (placement === 'top' || placement === 'bottom') {
            return "translateY(" + (placement === 'top' ? distance : -distance) + "px)";
        }
    };
    Drawer.prototype.getParentDrawerStyle = function () {
        var push = this.state.push;
        var placement = this.props.placement;
        return {
            transform: push ? this.getPushTransform(placement) : undefined,
        };
    };
    Drawer.prototype.renderWrapper = function () {
        var wrapperStyle = {};
        var otherProps = omit(this.props, ['push', 'titleStyle', 'footer', 'footerStyle']);
        var maskStyle = otherProps.maskStyle, placement = otherProps.placement, bodyStyle = otherProps.bodyStyle, style = otherProps.style, zIndex = otherProps.zIndex, width = otherProps.width, title = otherProps.title, height = otherProps.height, rest = __rest(otherProps, ["maskStyle", "placement", "bodyStyle", "style", "zIndex", "width", "title", "height"]);
        var rootStyle = {};
        switch (placement) {
            case 'bottom':
            case 'top':
                wrapperStyle = { height: height + "px" };
                rootStyle = this.props.mask === false ? { height: 'auto' } : {};
                break;
            case 'right':
            case 'left':
                wrapperStyle = { width: width + "px" };
                rootStyle = this.props.mask === false ? { width: 'auto' } : {};
                break;
        }
        var position = {};
        if (this.props.getContainer === false) {
            position = {
                position: 'absolute',
            };
        }
        var parentDrawerStyle = this.getParentDrawerStyle();
        return this.opened ? (React.createElement(DivTag, __assign({ ref: this.divRef }, rest, { name: Drawer.NAME, atomics: ['h-full', 'w-full'], onTransitionEnd: this.handleTransitionEnd, style: __assign(__assign(__assign({ zIndex: zIndex }, style), position), rootStyle), className: "drawer-" + placement, autoPrefixedClassName: "drawer-portal" }),
            this.props.mask ? (React.createElement(DivTag, { autoPrefixedClassName: "drawer-mask", style: maskStyle, onClick: this.handleMaskClose, atomics: ['absolute', 'w-full', 'h-full', 'top-0', 'left-0'] })) : null,
            React.createElement(DivTag, { autoPrefixedClassName: "drawer-content-wrapper", atomics: ['absolute'], style: __assign(__assign({}, wrapperStyle), parentDrawerStyle) },
                React.createElement(DivTag, { autoPrefixedClassName: "drawer-content", atomics: ['h-full', 'w-full'] },
                    React.createElement(DivTag, { autoPrefixedClassName: "drawer-wrapper-body", style: bodyStyle, atomics: ['flex', 'flex-col', 'w-full', 'h-full', 'bg-white'] },
                        this.renderTitle(),
                        React.createElement(DivTag, { autoPrefixedClassName: "drawer-body", atomics: ['w-full', 'py-px-16', 'px-px-24'] }, this.props.children),
                        this.renderFooter()))))) : null;
    };
    Drawer.prototype.render = function () {
        return React.createElement(DrawerContext.Consumer, null, this.renderProvider);
    };
    Drawer.NAME = 'drawer';
    Drawer.displayName = 'Drawer';
    Drawer.defaultProps = defaultProps;
    return Drawer;
}(PureComponent));
export { Drawer };
Drawer.contextType = DrawerContext;
